const translation = {
  toVerifiedTip: {
    coupon: 'ekskluzywny kupon 100%',
    front: 'Teraz jesteś uprawniony do statusu zweryfikowanej edukacji. Proszę wprowadzić swoje informacje edukacyjne poniżej, aby zakończyć proces i otrzymać',
    end: 'dla Profesjonalnego Planu Dify.',
  },
  form: {
    schoolName: {
      title: 'Nazwa Twojej Szkoły',
      placeholder: 'Wpisz oficjalną, pełną nazwę swojej szkoły',
    },
    schoolRole: {
      option: {
        student: 'Uczniowie',
        teacher: 'Nauczyciel',
        administrator: 'Administrator szkoły',
      },
      title: 'Twoja rola w szkole',
    },
    terms: {
      desc: {
        termsOfService: 'Warunki świadczenia usług',
        privacyPolicy: 'Polityka prywatności',
        and: 'i',
        front: 'Twoje informacje i użycie statusu Weryfikowanej Edukacji podlegają naszym',
        end: 'Przez przesłanie:',
      },
      option: {
        age: 'Potwierdzam, że mam co najmniej 18 lat',
        inSchool: 'Potwierdzam, że jestem zapisany lub zatrudniony w podanej instytucji. Dify może wymagać dowodu zapisania/zatrudnienia. Jeśli wprowadzę w błąd dotyczący mojej zdolności do uczestnictwa, zgadzam się zapłacić wszelkie opłaty, które zostały początkowo zaniechane w oparciu o mój status edukacyjny.',
      },
      title: 'Warunki i umowy',
    },
  },
  toVerified: 'Uzyskaj potwierdzenie edukacji',
  submit: 'Zatwierdź',
  rejectContent: 'Niestety, nie kwalifikujesz się do statusu Zweryfikowanej Edukacji i w związku z tym nie możesz otrzymać ekskluzywnego kuponu 100% na plan Dify Professional, jeśli korzystasz z tego adresu e-mail.',
  successContent: 'Wydaliśmy kupon rabatowy na 100% dla planu Dify Professional na Twoje konto. Kupon jest ważny przez jeden rok, prosimy o jego użycie w okresie ważności.',
  currentSigned: 'AKTUALNIE ZALOGOWANY JAKO',
  successTitle: 'Masz zweryfikowane wykształcenie Dify',
  rejectTitle: 'Twoja weryfikacja edukacyjna Dify została odrzucona',
  learn: 'Dowiedz się, jak uzyskać potwierdzenie wykształcenia',
  emailLabel: 'Twój aktualny email',
  submitError: 'Przesłanie formularza nie powiodło się. Proszę spróbować ponownie później.',
}

export default translation
